<template>
  <div style="width:100%">
    <div style="padding:20px">
      <el-table
          :data="examList.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
          :stripe="true"
          :current-page.sync="currentPage"
          v-loading="loading">
        <el-table-column label="试卷名" prop="test_name"></el-table-column>
        <el-table-column label="试卷介绍" prop="test_instruction"></el-table-column>
        <el-table-column label="学科" prop="test_subject"></el-table-column>
        <el-table-column label="考试时长" prop="test_duration" width="120px"></el-table-column>
        <el-table-column label="测试者" width="140px">
          <template slot-scope="scope">
            {{ scope.row.taker ? scope.row.taker.student_lastName + scope.row.taker.student_givenName : '' }}
          </template>
        </el-table-column>
        <el-table-column label="完成情况" prop="test_status" width="120px"></el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[50, 100, 150]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getExerciseTests } from '../api/examAdmin'

export default {
  data () {
    return {
      currentPage: 1,
      pageSize: 50,
      total: 0,
      examList: [],
      loading: false
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    },
    fetchData () {
      this.loading = true
      getExerciseTests().then(res => {
        if (res.data.code === 0) {
          this.examList = res.data.data
          this.total = this.examList.length
          this.loading = false
        }
      })
    }
  }
}
</script>

<style>

</style>
